module.exports = __webpack_public_path__ + "translations/en/subreddit.json";


//////////////////
// WEBPACK FOOTER
// ./translations/en/subreddit.json
// module id = ./translations/en/subreddit.json
// module chunks = 1